import { Box, CardMedia } from '@mui/material';
import { ScanStatus } from '../../../type';
import { useCallback, useContext } from 'react';
import { MediaErrorMessageAwareContext } from '../by-side/MediaErrorMessageAware';

type RemoteVideoMessageProps = {
  url?: string;
  thumbnailUrl?: string;
  fileName?: string;
  scanStatus?: ScanStatus;
};

export const RemoteVideoMessage = (props: RemoteVideoMessageProps) => {
  const errorAwareContext = useContext(MediaErrorMessageAwareContext);
  const onError = useCallback(() => {
    if (errorAwareContext) {
      errorAwareContext.onError();
    }
  }, [errorAwareContext]);
  return (
    <Box>
      <CardMedia
        sx={{ borderRadius: 3, maxWidth: 500 }}
        component='video'
        image={props.url}
        poster={props.thumbnailUrl}
        controls
        onError={onError}
      />
    </Box>
  );
};
